import { render, staticRenderFns } from "./edit-customer-info.pug?vue&type=template&id=7bd3dc34&lang=pug&"
import script from "./edit-customer-info.ts?vue&type=script&lang=ts&"
export * from "./edit-customer-info.ts?vue&type=script&lang=ts&"
import style0 from "./edit-customer-info.styl?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports